import React, { useState } from 'react';
// MATERIALS
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Typography from '@material-ui/core/Typography';
import AllInbox from '@material-ui/icons/AllInbox';
import { useTranslation } from 'react-i18next';
import { ListItemIcon } from '@material-ui/core';

const defaultState = {
  isOpen: false,
  anchorEl: null,
};

function TableActionMenu(props) {
  const { t } = useTranslation();
  const [state, setState] = useState(defaultState);

  const {
    menuItems,
    buttonFullWidth = true,
    buttonSize = 'small',
    buttonVariant = 'contained',
    buttonClassName = '',
  } = props;

  const handleClose = () => {
    setState({ isOpen: false, anchorEl: null });
  };

  const handleClick = (event) => {
    if (state.isOpen) {
      handleClose();
      return;
    }
    setState({
      isOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  const loadMenu = (labelMenu, listItem) => [
    <MenuItem key={`${labelMenu}-title`} disabled>
      <Typography variant="caption" component="caption">
        {labelMenu.toUpperCase()}
      </Typography>
    </MenuItem>,
    listItem.map((item, index) => (
      <MenuItem
        key={`${labelMenu}-${index}-${item.label}`}
        disabled={item.disabled}
        onClick={() => {
          if (item.params) {
            item.onClick(...item.params);
          } else {
            item.onClick();
          }
          handleClose();
        }}>
        {item.icon && (
          <ListItemIcon>
            <item.icon fontSize="small" />
          </ListItemIcon>
        )}
        <Tooltip title={item.titleTooltip ? item.titleTooltip : ''}>
          <div style={{ whiteSpace: 'nowrap' }}>{item.label}</div>
        </Tooltip>
      </MenuItem>
    )),
  ];

  const loadedMenuItems = menuItems.map((listMenu) => {
    if (listMenu.component) {
      const Component = listMenu.component;
      return <Component style={{ margin: '0.5rem 0' }} />;
    }
    const { label, listItems } = listMenu;
    return loadMenu(label, listItems);
  });

  return (
    <>
      <Button
        className={buttonClassName}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        color="primary"
        variant={buttonVariant}
        fullWidth={buttonFullWidth}
        size={buttonSize}
        startIcon={<AllInbox />}>
        {t('Actions')}
      </Button>
    <Popover
      open={state.isOpen}
      anchorEl={state.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
      }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            minWidth: Math.max(state.anchorEl?.offsetWidth || 0, 220),
            width: 'max-content',
            maxWidth: 'calc(100vw - 32px)',
            marginTop: '0.5rem',
          },
          elevation: 2,
        }}>
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList>{loadedMenuItems}</MenuList>
          </ClickAwayListener>
        </Paper>
      </Popover>
    </>
  );
}

export default TableActionMenu;
